import { Gender, type KnownGender } from 'src/models/resume/resumeCommon.types';

export function ensureKnownGender(gender?: Gender | string): KnownGender | undefined {
    return isGender(gender || '') && gender !== Gender.Unknown ? (gender as KnownGender) : undefined;
}

export function isGender(gender: string): gender is Gender {
    return Object.values(Gender).includes(gender as Gender);
}
